import { useReducer } from 'react';

import { CurrentFcStore, GlobalState, TypeParamsNavigator } from './Global.interface';
import { GlobalContext } from './GlobalContext';
import { globalReducer } from './GlobalReducer';

const INITIAL_STATE: GlobalState = {
    isLoggedIn: !!localStorage.getItem('access_token'),
    isLoading: false,
    currentFcStore: { franchiseId: '', storeId: '' },
    paramsNavigator: {
        router: '',
        state: {},
    },
};

interface props {
    children: JSX.Element | JSX.Element[];
}

export const GlobalProvider = ({ children }: props) => {
    const [globalState, dispatch] = useReducer(globalReducer, INITIAL_STATE);

    const setParamsNavigator = (params: TypeParamsNavigator) => {
        dispatch({ type: 'setParamsNavigator', payload: params });
    };

    const setLoggedIn = (isLoggedIn: boolean) => {
        dispatch({ type: 'setLoggedIn', payload: isLoggedIn });
    };

    const setLoading = (isLoading: boolean) => {
        dispatch({ type: 'setLoading', payload: isLoading });
    };

    const setCurrentFcStore = (currentFcStore: CurrentFcStore) => {
        dispatch({ type: 'setCurrentFcStore', payload: currentFcStore });
    };

    return (
        <GlobalContext.Provider
            value={{
                globalState,
                setLoggedIn,
                setLoading,
                setCurrentFcStore,
                setParamsNavigator,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};
